import React from 'react';
import { connect } from 'react-redux';
import { SubMenuLink } from "./SubMenuLink";
import _ from "i18n";

const Statistics = ({ currentClient, loggedAs, user, subMenuDirection }) => {

  if (loggedAs === "ADMIN" || (user && user.type === "ADMIN")) {
    return (
      <SubMenuLink
        pathname="/admin/eventstats"
        title={_('stats')}
        icon="STATISTICS"
        subMenuDirection={subMenuDirection}
        currentClient={currentClient}
      />
    );
  }

  return null;
};

const mapStateToProps = (store) => ({
  currentClient: store.auth.currentClient,
  loggedAs: store.auth.loggedAs,
  user: store.auth.user,
});

export default connect(mapStateToProps)(Statistics);


// WEBPACK FOOTER //
// ./app/components/menu/Statistics.js